import { useCartStore } from '~/stores/cartStore'

export default defineNuxtPlugin(async (nuxtApp) => {
  // Use the 'app:mounted' hook to delay store access
  nuxtApp.hooks.hook('app:mounted', async () => {
    // Initialize cart store on client-side only
    if (process.client) {
      const cartStore = useCartStore()

      // Load cart state from localStorage
      cartStore.loadClientState()
    }
  })
})
